<header class="sf-header">
  <h1>{{ 'services.title' | transloco }}</h1>

  <button class="button"
    (click)="openCreateServiceModal()"
    >
    <i class="fa-solid fa-plus"></i>
    {{ 'services.add-service' | transloco }}
  </button>
</header>

<div class="services">
  <div class="sf-section services__explanation">
    <div class="left">
      <div class="services__explanation-title">
        <i class="fa-solid fa-circle-question"></i>
        <h2>{{'services.explanation.title'|transloco}}</h2>
      </div>
      <p>{{'services.explanation.content'|transloco}}</p>
    </div>
  </div>

  @if (!loadingServices) {
    @if (services.length === 0) {
      <div class="sf-section services__empty-state">
        <i class="fa-solid fa-box-open services__empty-state-icon"></i>
        <h2 class="services__empty-state-title">{{'services.empty-state.title'|transloco}}</h2>
        <p class="services__empty-state-subtitle">{{'services.empty-state.content'|transloco}}</p>
        <button class="services__empty-state-button button"
          (click)="openCreateServiceModal()"
          >
          {{'services.empty-state.button.label'|transloco}}
        </button>
      </div>
    }
    @if (services.length > 0) {
      <div class="sf-section">
        <div class="services__list-header">
          <div class="services__list-header-item services__list-header-item--service">Service</div>
          <div class="services__list-header-item services__list-header-item--service">Online status</div>
        </div>
        <div
          class="services__list"
          cdkDropList
          (cdkDropListDropped)="drop($event)"
          [cdkDropListSortingDisabled]="false"
          [cdkDropListOrientation]="'mixed'"
          >
          @for (service of services; track service) {
            <div
              class="services__list-item"
              cdkDrag
              >
              <div class="services__list-item__drag-icon">
                <i class="fa-solid fa-arrows-up-down-left-right"></i>
              </div>
              <app-service-item
                [service]="service"
                (onEdit)="onEditService($event)"
                (deleted)="onServiceDeleted($event)"
              ></app-service-item>
            </div>
          }
        </div>
      </div>
    }
  }

</div>

<app-create-service-modal
  [open]="createServiceModalOpened"
  [service]="serviceToEdit"
  (closed)="closeCreateServiceModal($event)"
  (deleted)="onServiceDeleted($event)"
></app-create-service-modal>
